var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('honjo-file-link',{attrs:{"data-source":_vm.dataSource,"download-fn":_vm.downloadFn}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }